import cx from "classnames";
import Button from "components/Shared/Button";
import Checkbox from "components/Shared/Checkbox";
import SubTitle from "components/Shared/SubTitle";
import Title from "components/Shared/Title";
import React from "react";
import { OnboardingProps } from "types";

export const OnboardingTemplate = (props: OnboardingProps): React.ReactElement => {
  const { loaders, templates, selectedTemplates, setSelectedTemplates, handleOnboardTemplates } =
    props;

  return (
    <>
      <div className="text-center flex flex-col items-center">
        <Title className="text-center">Setup products</Title>
        <SubTitle className="max-w-[510px]">
          Get started with pre-configured products from our template gallery. You can also create
          more products later
        </SubTitle>
        <Button
          onClick={() => handleOnboardTemplates()}
          type="button"
          loading={loaders.onboardingTemplates}
          className="mt-6 my-12 min-w-60">
          Continue
        </Button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 2xl:grid-cols-3 gap-4 mt-8">
        {templates.map((template) => {
          const isSelected = !!selectedTemplates.find(
            (selectedTemplate) => selectedTemplate == template.id
          );
          const handleSelect = () =>
            setSelectedTemplates((prev) => {
              if (isSelected) {
                return prev.filter((selectedTemplate) => selectedTemplate != template.id);
              }
              return [...prev, template.id];
            });
          return (
            <div onClick={handleSelect} className="w-full cursor-pointer" key={template.id}>
              <div
                className={cx(
                  "flex gap-4 items-center p-2 border rounded-xl border-soft-grey",
                  isSelected && "!border-primary"
                )}>
                <img
                  src={template.thumbnailUrl || "/images/thumbnail.jpg"}
                  alt={template.name}
                  className="w-14 h-14 rounded-lg object-cover"
                  onError={(e) => {
                    e.currentTarget.onerror = null; // Prevents infinite loop
                    e.currentTarget.src = "/images/thumbnail.jpg";
                  }}
                />
                <p className="text-sm md:text-base font-bold grow">{template.name}</p>
                <Checkbox checked={isSelected} onChange={handleSelect} name="template" />
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};
